import { createSelector } from '@reduxjs/toolkit';

export const selectReportsData = createSelector(
  [(state: any) => state.vpoStrapi.reports?.data],
  (data) => data || null
);

export const selectReportsLoading = createSelector(
  [(state: any) => state.vpoStrapi.reports?.loading],
  (loading) => loading || false
);

export const selectReportsError = createSelector(
  [(state: any) => state.vpoStrapi.reports?.error],
  (error) => error || null
);
